export default __webpack_public_path__ + "static/media/Banner - EarBuddyz PRO - White.7af4df28.jpg";